export default function Committente({ committente = {} }) {
  return (
    <section
      aria-labelledby="applicant-information-title"
      className="col-span-2"
    >
      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h2
            id="applicant-information-title"
            className="text-lg font-medium leading-6 text-gray-900"
          >
            Informazioni del Committente
          </h2>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Nome</dt>
              <dd className="mt-1 flex items-center gap-x-2 text-sm text-gray-900">
                {committente.logo && (
                  <img src={committente.logo} className="my-auto h-8 w-8" />
                )}
                {committente.nome}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">RUP</dt>
              <dd className="mt-1 text-sm text-gray-900">{committente.rup}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Telefono</dt>
              <dd className="mt-1 text-sm text-gray-900">
                {committente.telefono}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Indirizzo</dt>
              <dd className="mt-1 text-sm text-gray-900">
                {committente.indirizzo}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Mail</dt>
              <dd className="mt-1 text-sm text-gray-900">{committente.mail}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Pec</dt>
              <dd className="mt-1 text-sm text-gray-900">{committente.pec}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
